var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        width: _vm.size,
        height: _vm.size,
        viewBox: "0 0 13 13",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }
    },
    [
      _c("path", {
        attrs: {
          d:
            "M6.49992 1.08331C3.51534 1.08331 1.08325 3.5154 1.08325 6.49998C1.08325 9.48456 3.51534 11.9166 6.49992 11.9166C9.4845 11.9166 11.9166 9.48456 11.9166 6.49998C11.9166 3.5154 9.4845 1.08331 6.49992 1.08331ZM8.85617 8.43373C8.78034 8.56373 8.64492 8.63415 8.50409 8.63415C8.43367 8.63415 8.36325 8.6179 8.29825 8.57456L6.61909 7.57248C6.202 7.32331 5.89325 6.77623 5.89325 6.29415V4.07331C5.89325 3.85123 6.07742 3.66706 6.2995 3.66706C6.52159 3.66706 6.70575 3.85123 6.70575 4.07331V6.29415C6.70575 6.48915 6.86825 6.77623 7.03617 6.87373L8.71534 7.87581C8.91034 7.98956 8.97534 8.23873 8.85617 8.43373Z",
          fill: _vm.color
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }